import React, { useState, useEffect } from "react";
import infoIcon from "../../../../../assets/images/Icons/info_icon.svg";
import { useSelector, useDispatch } from "react-redux";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
} from "../../../../../helpers/global_helper";
import { setCommonConfig } from "../../../../../redux/actions";
import QuickBuyInformationPopup from "./QuickBuyInformationPopup";
import QuickBuyBetDetailsPopup from "./QuickBuyBetDetailsPopup";
import QuickBuyBetInCompleteDetailsPopup from "../../../../Popups/QuickBuyBetInCompleteDetailsPopup";
import { withTranslation } from "react-i18next";
import UseBodyScrollLock from "../../../../Popups/UseBodyScrollLock";
import GameClosedPopup from "../../GameClosedPopup";
import MarketClose from "../../MarketClose";
const QuickBuy = (props) => {
  const device = useSelector(state => state.CommonConfig.device_type);
  const dispatch = useDispatch();
  const betDiscount = useSelector((state) => state.CommonConfig.discount);

  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType = useSelector((state) => state.CommonConfig.gameType);

  const [popupComponent, setPopupComponent] = useState(false);
  const [betDetailTable, setBetDetailTable] = useState(false);
  const [betDetailIncompletePopup, setBetDetailIncompletePopup] =
    useState(false);
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [enterStatus, setEnterStatus] = useState(0);

  const [inputValues, setInputValues] = useState({
    gameId: null,
    allowPartner: "allowPartner",
    gameType: "quickbuy",
    number: "",
  });
  const [RespDataBet, setRespDataBet] = useState({
    dataBet: [],
    totalBet: [],
    gameType: "",
    betGenerated: "",
  });

  useEffect(() => {
    dispatch(setCommonConfig({ key: "gameType", value: "quickbuy" }));
  }, []);
  UseBodyScrollLock(betDetailTable);
  UseBodyScrollLock(popupComponent);
  const handlePopupOpen = () => {
    setPopupComponent(true);
  };
  const handleClosePopup = () => {
    setPopupComponent(false);
  };
  const handleBetDetailPopup = () => {
    setBetDetailTable(false);

  }
  const handleBetDetailIncompletePopup = () => [
    setBetDetailIncompletePopup(false),
  ];

  const handleChange = (e, type) => {
    setEnterStatus(0);
    const { name, value } = e.target;
    setInputValues((prevState) => ({
      ...prevState,
      gameId: gameId,
      [name]: value,
    }));
  };

  useEffect(() => {
    handleReset();
  }, [gameId]);

  const handleReset = () => {
    setInputValues((prevValues) => ({
      ...prevValues,
      gameId: gameId,
      allowPartner: "allowPartner",
      gameType: "quickbuy",
      number: "",
    }));
  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const generateProcess = () => {
    if (enterStatus == 0) {
      inputValues.number = inputValues.number.replace(/×/g, '=');
      makeAjax(url.TOGEL_API.generateQuickBet, inputValues).then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
          showMessage(response);
          return;
        }
        Object.keys(response.data.databet).forEach((key) => {
          if (response.data.databet[key].length > 0 || response.data.tempdatabeterror) {
            setRespDataBet((prevState) => ({
              ...prevState,
              dataBet: response.data.databet,
              gameType: key,
              number: inputValues.number,
            }));
          }
        });
        const updatedBet = {};
        Object.keys(response.data.totalbet).forEach((key) => {
          if (response.data.totalbet[key] > 0 || response.data.tempdatabeterror) {
            updatedBet[key] = response.data.totalbet[key];
          }
          setRespDataBet((prevState) => ({
            ...prevState,
            totalBet: updatedBet,
            betGenerated: response.data.betGenerated,
            tempdatabeterror: response.data.tempdatabeterror
          }));
        });
        setEnterStatus(1);
        setBetDetailIncompletePopup(false);
        setBetDetailTable(true);
      });
    }
  };

  return (
    <div className="quickbuy_wrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          <div className="main_section">
            <div className="left_section">
              <p className="txt_name" style={{ textTransform: "uppercase" }}>
                {props.t("bet")}
              </p>
              <p className="txt_price">*Conversion 1 = {betDiscount.showMultipleNomor} IDR</p>
            </div>
            <div className="right_section">
              <textarea
                rows={14}
                cols={54}
                name="number"
                value={inputValues["number"]}
                onChange={(e) => handleChange(e, "number")}
              />
              <p>{props.t("description")} :</p>
              <p>
                {props.t("quickbuy_description")}
                {
                  device === "Mobile" && <span className="info_Icon"><img src={infoIcon} alt="" onClick={() => handlePopupOpen()} /></span>}
                <div className="info_Icon">
                  <span>bet | Conversion 1 = {betDiscount.showMultipleNomor} </span>
                  {
                    device === "Desktop" && <><img src={infoIcon} alt="" onClick={() => handlePopupOpen()} /></>}

                </div>
              </p>
            </div>
          </div>
          <div className="last_div">
            <div className="left_div">
              <p>{props.t("quickbuy_note")}</p>
            </div>
            <div className="right_div">
              <ul className="button-list">
                <li>
                  <button className="reset" onClick={handleReset}>
                    {props.t('reset')}
                  </button>
                </li>
                <li>
                  <button className="submit" onClick={generateProcess}>
                    {props.t('submit')}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}

      {betDetailTable && (
        <QuickBuyBetDetailsPopup
          response={RespDataBet}
          onClose={handleBetDetailPopup}
          onReset={handleReset}
        />
      )}
      {betDetailIncompletePopup && (
        <QuickBuyBetInCompleteDetailsPopup
          response={inputValues}
          onClose={handleBetDetailIncompletePopup}
        />
      )}
      {popupComponent && (
        <QuickBuyInformationPopup onClose={handleClosePopup} />
      )}
    </div>
  );
};

export default withTranslation()(QuickBuy);
